import React, { FC,  useEffect, useState } from "react";

type Props ={ 
    time:number;
}

const CountDown : FC<Props> = ({
    time
  }) => {

    const countDownDate = new Date(time*1000).getTime();
    const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());

    useEffect(() => {
        const interval = setInterval(() => {
          //console.log(countDownDate - new Date().getTime())
          setCountDown(countDownDate - new Date().getTime());
        }, 1000);
    
        return () => clearInterval(interval);
      }, [countDownDate]);
      //console.log(countDown);

      const getReturnValues = (countDown:number) => {
        // calculate time left
        const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
        //console.log(days)
        const hours = Math.floor(
          (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
      
        return [days, hours, minutes, seconds].map(unit => String(unit).padStart(2, '0'));
      };
    if(countDown>0){
        const[days, hours, minutes, seconds] = getReturnValues(countDown)
        return(
            <div className="text-center">{`${days}:${hours}:${minutes}:${seconds}`}</div>
        );
    }else{
        return(<div>{' '}</div>)
    }
};

export default CountDown;
